(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["referral-attribution"] && !Shopify.designMode) return;
  try {
    (() => {
    const TOKEN_COOKIE = 'toreca_ref_token';
    const FIRST_TOUCH_COOKIE = 'toreca_ref_first_touch_at';
    const BANNER_SESSION_KEY = 'toreca_referral_banner_seen';
    const COOKIE_MAX_AGE = 60 * 60 * 24 * 30;
    const TOKEN_PATTERN = /^v1\.[A-Za-z0-9_-]{40,600}\.[A-Za-z0-9_-]{43}$/;
    const BATCH_TOKEN_KEY = '_toreca_ref_token';
    const BATCH_FIRST_TOUCH_KEY = '_toreca_ref_first_touch_at';

    const readCookie = (name) => {
      const prefix = `${encodeURIComponent(name)}=`;
      const item = document.cookie
        .split(';')
        .map((part) => part.trim())
        .find((part) => part.startsWith(prefix));
      if (!item) return '';
      try {
        return decodeURIComponent(item.slice(prefix.length));
      } catch (error) {
        return '';
      }
    };

    const writeCookie = (name, value) => {
      document.cookie = [
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
        'Path=/',
        `Max-Age=${COOKIE_MAX_AGE}`,
        'SameSite=Lax',
        'Secure',
      ].join('; ');
    };

    const sessionRead = (key) => {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const sessionWrite = (key, value) => {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        // Storage can be unavailable in hardened browsers; the banner remains dismissible.
      }
    };

    const referralUrl = new URL(window.location.href);
    const queryToken = referralUrl.searchParams.get('ref_token') || '';
    const fragmentParams = new URLSearchParams(referralUrl.hash.slice(1));
    const fragmentToken = fragmentParams.get('ref_token') || '';
    const incomingToken =
      queryToken && fragmentToken && queryToken !== fragmentToken
        ? ''
        : fragmentToken || queryToken;
    let token = readCookie(TOKEN_COOKIE);
    let firstTouch = readCookie(FIRST_TOUCH_COOKIE);

    if (!TOKEN_PATTERN.test(token)) {
      token = '';
      firstTouch = '';
    }

    if (!token && TOKEN_PATTERN.test(incomingToken)) {
      token = incomingToken;
      firstTouch = new Date().toISOString();
      writeCookie(TOKEN_COOKIE, token);
      writeCookie(FIRST_TOUCH_COOKIE, firstTouch);
    }

    if (referralUrl.searchParams.has('ref_token') || fragmentParams.has('ref_token')) {
      referralUrl.searchParams.delete('ref_token');
      if (fragmentParams.has('ref_token')) {
        fragmentParams.delete('ref_token');
        const cleanFragment = fragmentParams.toString();
        referralUrl.hash = cleanFragment ? `#${cleanFragment}` : '';
      }
      window.history.replaceState(
        window.history.state,
        '',
        `${referralUrl.pathname}${referralUrl.search}${referralUrl.hash}`,
      );
    }

    if (token) {
      document.documentElement.dataset.torecaReferral = 'invited';
    }

    const banner = document.querySelector('[data-referral-landing-banner]');
    if (banner && token && sessionRead(BANNER_SESSION_KEY) !== 'true') {
      banner.hidden = false;
      sessionWrite(BANNER_SESSION_KEY, 'true');
      banner.querySelector('[data-referral-banner-close]')?.addEventListener('click', () => {
        banner.hidden = true;
      });
    }

    if (!token) return;
    if (!firstTouch) {
      firstTouch = new Date().toISOString();
      writeCookie(FIRST_TOUCH_COOKIE, firstTouch);
    }

    const rootPath = window.Shopify?.routes?.root || '/';
    const cartUrl = `${rootPath}cart.js`;
    const cartUpdateUrl = `${rootPath}cart/update.js`;
    const hasValue = (attributes, key) =>
      Object.prototype.hasOwnProperty.call(attributes, key) && String(attributes[key] || '') !== '';

    const syncCartAttribution = async () => {
      const cartResponse = await fetch(cartUrl, {
        credentials: 'same-origin',
        headers: {Accept: 'application/json'},
      });
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const attributes = cart.attributes || {};
      if (hasValue(attributes, BATCH_TOKEN_KEY)) {
        return;
      }

      await fetch(cartUpdateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [BATCH_TOKEN_KEY]: token,
            [BATCH_FIRST_TOUCH_KEY]: firstTouch,
          },
        }),
      });
    };

    syncCartAttribution().catch(() => {
      // A later navigation retries from the first-party cookie without exposing the token.
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-sidebar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindScrollShadow = (frame) => {
      if (frame.dataset.sidebarScrollShadowBound === 'true') return;
      const scrollport = frame.querySelector('[data-site-sidebar-scrollport]');
      if (!scrollport) return;
      frame.dataset.sidebarScrollShadowBound = 'true';

      let queued = false;
      const sync = () => {
        queued = false;
        const remaining = scrollport.scrollHeight - scrollport.clientHeight - scrollport.scrollTop;
        frame.dataset.sidebarHasMore = remaining > 1 ? 'true' : 'false';
      };
      const queueSync = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      };

      scrollport.addEventListener('scroll', queueSync, { passive: true });
      window.addEventListener('resize', queueSync, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(queueSync).observe(scrollport);
      queueSync();
    };

    document.querySelectorAll('[data-site-sidebar-scroll-frame]').forEach(bindScrollShadow);
  })();
  } catch(e) { console.error(e); }
})();

})();
